import api from './api'

const baseUrl = '/consents'
const part = (part) => `${part ? '/' + part : ''}`
const url = (...parts) => baseUrl + parts.map(part).join('')

// https://fonixtelematics.atlassian.net/wiki/spaces/DLC/pages/33751041/API

const dataOrDefault = (request, defData) => (request.data || defData)
const toArray = (request) => dataOrDefault(request, [])

export default {

  getAll () {
    return api.get(url()).then(toArray)
  },

  getSingle (id) {
    return api.get(url(id)).then(dataOrDefault)
  },

  accept (id) {
    return api.post(url(id, 'accept'))
  },

  grant (id, pin) {
    return api.post(url(id, 'grant'), { pin })
  },

  revoke (id) {
    return api.delete(url(id))
  }
}



// WEBPACK FOOTER //
// ./src/services/api/consents.js